import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import { monthsList } from 'src/environments/date/date';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { buildProviders, Coerce } from '@kalidea/kaligraphi';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-shared-month-range-picker',
    templateUrl: './shared-month-range-picker.component.html',
    styleUrls: ['./shared-month-range-picker.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedMonthRangePickerComponent),
    standalone: false
})
export class SharedMonthRangePickerComponent extends CustomFormControlAccess implements OnInit {

    readonly monthsList = monthsList;
    form: UntypedFormGroup;

    @Coerce('boolean')
    @Input()
    displayMonthEnd = false;

    @Input() monthStartLabel = '';

    @Input() monthEndLabel = '';

    constructor(protected readonly fb: UntypedFormBuilder) {
        super();
    }

    writeValue(value: {startMonth: number, endMonth: number}): void {
        this.form.patchValue({
            startMonth: +value?.startMonth || null,
            endMonth: +value?.endMonth || null
        }, {emitEvent: false});

        const formValues = this.form.value;

        if (formValues.endMonth && !this.displayMonthEnd) {
            this.toggleMonthEnd();
        }

        this.form.updateValueAndValidity();
    }

    validate(c: AbstractControl): Observable<any> {
        return of(this.form.valid ? null : {monthrange: true});
    }

    toggleMonthEnd(): void {
        this.displayMonthEnd = !this.displayMonthEnd;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            startMonth: [null],
            endMonth: [null]
        });

        this.watch$ = this.form.valueChanges.pipe(
            distinctUntilChanged(),
            tap(values => this.notifyUpdate(values))
        );
    }
}
